import { get } from "lodash";
import { REGEX_EXPS } from "utils/constants";
import { validateIBAN } from "utils/helpers/values";
import * as yup from "yup";

const validation = (messages) => {
  const string = yup
    .string()
    .typeError(messages.NOT_STRING)
    .required(messages.REQUIRED)
    .nullable();
  const nameValidation = yup
    .string()
    .typeError(messages.NOT_STRING)
    .nullable()
    .notRequired()
    .test(
      "is-valid-name",
      messages.INVALID_NAME,
      (value) => !value || REGEX_EXPS.name.test(value),
    );
  return yup.object().shape({
    payment: yup.object().shape({
      type: string,
      frequency: string,
      debitDay: string,
      payer: yup.object().shape({
        BIC: string,
        IBAN: yup
          .string()
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .test("validateIBAN", messages.INVALID_IBAN, function (value, ctx) {
            const result = validateIBAN(value);
            if (!result.valid)
              return ctx.createError({
                message: get(messages, result.reason, messages.INVALID_VALUE),
              });

            return true;
          }),
        owner: yup.object().shape({
          isAdherent: yup.boolean().typeError(messages.NOT_BOOLEAN),
          firstName: nameValidation,
          lastName: nameValidation,
        }),
      }),
      receiver: yup.object().shape({
        BIC: string,
        IBAN: yup
          .string()
          .typeError(messages.NOT_STRING)
          .required(messages.REQUIRED)
          .test("validateIBAN", messages.INVALID_IBAN, function (value, ctx) {
            const result = validateIBAN(value);
            if (!result.valid)
              return ctx.createError({
                message: get(messages, result.reason, messages.INVALID_VALUE),
              });

            return true;
          }),
        owner: yup.object().shape({
          firstName: nameValidation,
          lastName: nameValidation,
        }),
      }),
    }),
  });
};

export default validation;
